export enum USER_ROLE {
  ADMIN = 'admin',
  SUPER_ADMIN = 'superadmin',
  EDITOR = 'editor',
  USER = 'user',
}
